import { GenericError } from "@/assets/illustrations";
import { StatusCodes } from "http-status-codes";
import { ErrorScreenProps } from "./types";
import {
  GENERIC_ERROR_TITLE,
  GENERIC_ERROR_SUBTITLE,
  UNAUTHORIZED_ERROR_TITLE,
  UNAUTHORIZED_ERROR_SUBTITLE,
  UNAUTHORIZED_ERROR_BUTTON_TEXT,
  FORBIDDEN_ERROR_TITLE,
  FORBIDDEN_ERROR_SUBTITLE_FIRST_LINE,
  FORBIDDEN_ERROR_SUBTITLE_SECOND_LINE,
  FORBIDDEN_ERROR_BUTTON_TEXT,
  REQUEST_TIMEOUT_ERROR_TITLE,
  REQUEST_TIMEOUT_ERROR_SUBTITLE,
  INTERNAL_SERVER_ERROR_TITLE,
  INTERNAL_SERVER_ERROR_SUBTITLE,
  GENERIC_ERROR_SUBTITLE_MOBILE,
  INTERNAL_SERVER_ERROR_SUBTITLE_MOBILE,
} from "./constants";

export const GENERIC_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: GENERIC_ERROR_TITLE,
  subtitle: GENERIC_ERROR_SUBTITLE,
};

export const GENERIC_ERROR_MOBILE: ErrorScreenProps = {
  icon: <GenericError />,
  title: GENERIC_ERROR_TITLE,
  subtitle: GENERIC_ERROR_SUBTITLE_MOBILE,
};

export const UNAUTHORIZED_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: UNAUTHORIZED_ERROR_TITLE,
  subtitle: UNAUTHORIZED_ERROR_SUBTITLE,
  buttonText: UNAUTHORIZED_ERROR_BUTTON_TEXT,
};

export const FORBIDDEN_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: FORBIDDEN_ERROR_TITLE,
  subtitle: (
    <>
      <p>{FORBIDDEN_ERROR_SUBTITLE_FIRST_LINE}</p>
      <p>{FORBIDDEN_ERROR_SUBTITLE_SECOND_LINE}</p>
    </>
  ),
  buttonText: FORBIDDEN_ERROR_BUTTON_TEXT,
};

export const REQUEST_TIMEOUT_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: REQUEST_TIMEOUT_ERROR_TITLE,
  subtitle: REQUEST_TIMEOUT_ERROR_SUBTITLE,
};

export const INTERNAL_SERVER_ERROR: ErrorScreenProps = {
  icon: <GenericError />,
  title: INTERNAL_SERVER_ERROR_TITLE,
  subtitle: INTERNAL_SERVER_ERROR_SUBTITLE,
};

export const INTERNAL_SERVER_ERROR_MOBILE: ErrorScreenProps = {
  icon: <GenericError />,
  title: INTERNAL_SERVER_ERROR_TITLE,
  subtitle: INTERNAL_SERVER_ERROR_SUBTITLE_MOBILE,
};

export const getErrorConfig = (statusCode?: number) => {
  switch (statusCode) {
    case StatusCodes.UNAUTHORIZED:
      return UNAUTHORIZED_ERROR;
    case StatusCodes.FORBIDDEN:
      return FORBIDDEN_ERROR;
    case StatusCodes.REQUEST_TIMEOUT:
    case StatusCodes.GATEWAY_TIMEOUT:
      return REQUEST_TIMEOUT_ERROR;
    case StatusCodes.INTERNAL_SERVER_ERROR:
      return INTERNAL_SERVER_ERROR;
    default:
      return GENERIC_ERROR;
  }
};
